import { useEffect, useRef,useState} from "react";
import { getToken, getUserId,getInizioPeriodo,getFinePeriodo } from "../auth";
import funzione_collegamento from "../funzioni_server/pacchetti_lez_function.js";
import  differenzaOrario  from "../funzioni/differenza_ore";
import "../stili/tabelle.css";
import "../stili/popup.css";
import "../stili/tabs.css"
import "../stili/analisi.css"
import "../stili/agenda.css"
import convertDate from "../funzioni/converti_data";
import { DateTime } from 'luxon';
import nome_id from "../funzioni/nome_id.js"
import {convertiIdInventario,calcolaRimanenza,sovrapposti,convertiIdRuolo,convertiValuta,convertiIdEscursione,convertiTipoStorage,convertiIdNoleggio,ordinaPerData,prendiNomePacchetto,coloreDaId,guadagnoEscursione,pacchettiAperti,materialeDisponibile,istruttori_disponibili,isoToString,calcolaStipendioFisso,convertiCambi} from "../funzioni/funzioni_utili"
import ReactDOM from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faX, faPencil, faTrashCan,faCircleInfo,faSpinner,faChartSimple } from "@fortawesome/free-solid-svg-icons";
import Lottie from "lottie-react";
import animLoading from "../assets/loading.json";
import status_lezione from "../funzioni/status_lezione"
import {dizionarioTraduzioni} from "../funzioni/traduzioni";
/* global $ */

function Instructors() {
const inizioP=DateTime.fromISO(getInizioPeriodo()).toFormat("yyyyMMdd")
const fineP=DateTime.fromISO(getFinePeriodo()).plus({days:1}).toFormat("yyyyMMdd")
function generaStipendi(userid, salary, salarytype, startdate, enddate, stipendiPagati) {
  const oggi = DateTime.now().setZone("utc").startOf("day");
  const inizio = DateTime.fromFormat(startdate, "yyyyMMdd", { zone: "utc" }).startOf('day');
  const fineLavoro = enddate
    ? DateTime.fromFormat(enddate, "yyyyMMdd", { zone: "utc" }).startOf('day')
    : oggi;

  let stipendi = [];
   stipendiPagati = stipendiPagati.filter(emp => emp.salaryfixed === 0);
  const pagatiMap = new Map();
  for (let s of stipendiPagati) {
    const key = s.salarydateto;
    if (!pagatiMap.has(key)) {
      pagatiMap.set(key, { totale: 0, dati: [] });
    }
    pagatiMap.get(key).totale += s.importo;
    pagatiMap.get(key).dati.push({ ...s, pagato: true });
  }

  // Aggiungiamo direttamente gli stipendi già pagati
  for (let group of pagatiMap.values()) {
    for (let s of group.dati) {
      stipendi.push(s);
    }
  }
  if (salarytype === 1) {
    let data = inizio;

    while (data.weekday !== 4 && data.toMillis()!==fineLavoro.toMillis()) {
      data = data.plus({ days: 1 });
    }

    // Primo stipendio parziale se necessario
    if (inizio < data) {
      const giorni = data.diff(inizio, 'days').days;
      const importoParziale = Math.round((salary / 7) * giorni);
      const keyStart = inizio.toFormat("yyyyMMdd");
      const keyEnd = data.toFormat("yyyyMMdd");
      if (data <= oggi ) {
        const pagato = pagatiMap.get(keyEnd)?.totale || 0;
        const residuo = importoParziale - pagato;
        if (residuo ===salary  && !pagatiMap.has(keyEnd)) {
          stipendi.push({
            userid,
            salarydatefrom: keyStart,
            salarydateto: keyEnd,
            importo: residuo,
            pagato: false
          });
        }
      }
    }

    // Salari settimanali
    while (data <= oggi && data <= fineLavoro) {
      const keyStart = data.toFormat("yyyyMMdd");
      const dataFine = data.plus({ days: 7 });
      const keyEnd = dataFine.toFormat("yyyyMMdd");

      if (dataFine <= oggi && dataFine <= fineLavoro) {
        const pagato = pagatiMap.get(keyEnd)?.totale || 0;
        const residuo = salary - pagato;

        if (residuo === salary && !pagatiMap.has(keyEnd)) {
          stipendi.push({
            userid,
            salarydatefrom: keyStart,
            salarydateto: keyEnd,
            importo: residuo,
            pagato: false
          });
        }
      }

      data = data.plus({ days: 7 });
    }

  } else if (salarytype === 0) {
    // Mensile (1° del mese)
    let data = inizio;
    if (data.day !== 1) {
      const fineMese = data.endOf('month');
      const giorniLavorati = fineMese.diff(data, 'days').days + 1;
      const giorniTotali = fineMese.daysInMonth;
      const importoParziale = Math.round((salary / giorniTotali) * giorniLavorati);
      const keyStart = data.toFormat("yyyyMMdd");
      const keyEnd = fineMese.plus({ days: 1 }).startOf('day').toFormat("yyyyMMdd");

      if (fineMese <= oggi && fineMese <= fineLavoro) {
        const pagato = pagatiMap.get(keyEnd)?.totale || 0;
        const residuo = importoParziale - pagato;

        if (residuo === salary && !pagatiMap.has(keyEnd)) {
          stipendi.push({
            userid,
            salarydatefrom: keyStart,
            salarydateto: keyEnd,
            importo: residuo,
            pagato: false
          });
        }
      }

      data = fineMese.plus({ days: 1 }).startOf('month');
    }

    // Stipendi mensili regolari
    while (data <= oggi && data <= fineLavoro) {
      const keyStart = data.toFormat("yyyyMMdd");
      const dataFine = data.plus({ months: 1 });
      const keyEnd = dataFine.toFormat("yyyyMMdd");

      if (dataFine <= oggi && dataFine <= fineLavoro) {
        const pagato = pagatiMap.get(keyEnd)?.totale || 0;
        const residuo = salary - pagato;

        if (residuo === salary && !pagatiMap.has(keyEnd)) {
            stipendi.push({
            userid,
            salarydatefrom: keyStart,
            salarydateto: keyEnd,
            importo: residuo,
            pagato: false
          });
        }
      }

      data = data.plus({ months: 1 });
    }
  }

  // Ordinamento cronologico
  stipendi.sort((a, b) => a.salarydatefrom.localeCompare(b.salarydatefrom));
  return stipendi;
}


function mostraDettagliPagamenti(cellInfoUtente,periodi,stipendiUtente,lezioniUtente,pacchetti,noleggiUtente,noleggi){
    let periodiInteressati=[]
    for (let periodo of periodi){
        if (periodo.userid===cellInfoUtente.data.userid){
            periodiInteressati=[...periodiInteressati,periodo]
        }
    }
    periodiInteressati=ordinaPerData(periodiInteressati,"workperioddatefrom",true)
    const divGen=document.createElement("div")
    divGen.id="divGen"
    let rimanenzaTotale=0
    let rimanenzaLezioni=0
    let totaleOre=0
    let rimanenzaNol=0
    let totaleOreNol=0
    for (let periodo of periodiInteressati){
        let stipendiPeriodo=[]
        let stipendiPeriodoOre=[]
        for (let stipendio of stipendiUtente){
            if(  stipendio.salaryfixed===0 && (DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"})&&DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"}))  ){
                stipendiPeriodo=[...stipendiPeriodo,stipendio]
            }
            else if (  stipendio.salaryfixed===1 && (DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"})&&DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"}))  ) {
                stipendiPeriodoOre=[...stipendiPeriodoOre,stipendio]
            }
        }
        let lezioniPeriodo=[]
        for (let lezione of lezioniUtente){
            if( DateTime.fromFormat(lezione["lessondatestart"],"yyyyMMddHHmm",{zone:"utc"})<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"})&&DateTime.fromFormat(lezione["lessondatestart"],"yyyyMMddHHmm",{zone:"utc"})>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"})){
                lezioniPeriodo=[...lezioniPeriodo,lezione]
            }
        }
        let noleggiPeriodo=[]
        for (let noleggio of noleggiUtente){
            if( DateTime.fromFormat(noleggio["rentinvlinkfrom"],"yyyyMMddHHmm",{zone:"utc"})<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"})&&DateTime.fromFormat(noleggio["rentinvlinkfrom"],"yyyyMMddHHmm",{zone:"utc"})>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"})){
                noleggiPeriodo=[...noleggiPeriodo,noleggio]
            }
        }
        const stipendi = generaStipendi(
          cellInfoUtente.data.userid,
          periodo.workperiodfixedsalary,
          periodo.workperiodfixedsalaryfreq,
          periodo.workperioddatefrom,
          periodo.workperioddateto,
          stipendiPeriodo
        );
        for (let stipendio of stipendi){
            if (!stipendio.pagato){
                rimanenzaTotale+=stipendio.importo
            }
        }
        let totalePagatoV=0
        for (let stipendio of stipendiPeriodoOre){
            if (stipendio.salaryfixed!==0){
                totalePagatoV+=stipendio.salaryvalue
            }
        }
        let totaleGuadagnato=0
        for (let lezione of lezioniPeriodo){
            for (let pacchetto of pacchetti){
                if (pacchetto.lessonid===lezione.lessonid){
                    const nome = pacchetto.lessonstudentname
                    const numero = pacchetto.lessonnumstudents
                    const durata=(convertDate(lezione.lessondateend)-convertDate(lezione.lessondatestart))/(3600*1000)
                    let paga= numero===1?durata*(periodo.workperiodhourlypayment):durata*(periodo.workperiodhourlypaymentgroups)
                    if (cellInfoUtente.data.ruolo===5 && pacchetto.lessontype==="Avanzata"){
                        let commissionLez=0
                        if (lezione.inventories.length>0)
                            commissionLez=periodo.workperiodcommissionratelessonmaterial/100
                        else
                            commissionLez=periodo.workperiodcommissionratelesson/100
                        paga=((pacchetto.lessoncost * (1 - (pacchetto.lessondiscount || 0) / 100))*commissionLez*durata)/pacchetto.lessonpacket
                    }
                    rimanenzaTotale+=paga
                    rimanenzaLezioni+=paga
                    totaleOre+=durata
                    totaleGuadagnato+=paga
                }
            }
        }
        let daPagarCom=0
        let contatoreLezioniCom=0

        while (daPagarCom<0){
            const lezione=lezioniPeriodo[contatoreLezioniCom]
            for (let pacchetto of pacchetti){
                if (pacchetto.lessonid===lezione.lessonid){
                    const nome = pacchetto.lessonstudentname
                    const numero = pacchetto.lessonnumstudents
                    const durata=(convertDate(lezione.lessondateend)-convertDate(lezione.lessondatestart))/(3600*1000)
                    let paga= numero===1?durata*(periodo.workperiodhourlypayment):durata*(periodo.workperiodhourlypaymentgroups)
                    if (cellInfoUtente.data.ruolo===5 && pacchetto.lessontype==="Avanzata"){
                        let commissionLez=0
                        if (lezione.inventories.length>0)
                            commissionLez=periodo.workperiodcommissionratelessonmaterial/100
                        else
                            commissionLez=periodo.workperiodcommissionratelesson/100
                        paga=((pacchetto.lessoncost * (1 - (pacchetto.lessondiscount || 0) / 100))*commissionLez*durata)/pacchetto.lessonpacket
                    }

                }
            }
            contatoreLezioniCom+=1

        }
        daPagarCom+=totalePagatoV
        rimanenzaTotale-=totalePagatoV
        rimanenzaLezioni-=totalePagatoV
        for (let noleggio of noleggiPeriodo){
            if (noleggio.rentalpaid===0){
                const durata=(convertDate(noleggio.rentinvlinkto)-convertDate(noleggio.rentinvlinkfrom))/(3600*1000)
                let paga= durata*(periodo.workperiodcommissionrental)
                rimanenzaTotale+=paga
                rimanenzaNol+=paga
                totaleOreNol+=durata
            }
        }
    }
    const commentoRimanenza=document.createElement("h2")
    commentoRimanenza.id="commentoRimanenza"
        if (cellInfoUtente.data.ruolo===2 || cellInfoUtente.data.ruolo===5)
        commentoRimanenza.innerText=`Da pagare ancora a ${cellInfoUtente.data.nome} ${rimanenzaTotale.toFixed(2)}${convertiValuta(periodiInteressati[0]["workperiodfixedsalarycurrency"])}, di cui ${rimanenzaLezioni.toFixed(2)}${convertiValuta(periodiInteressati[0]["workperiodfixedsalarycurrency"])} di lezioni e ${rimanenzaTotale-rimanenzaLezioni}${convertiValuta(periodiInteressati[0]["workperiodfixedsalarycurrency"])} di fisso. Totale ore: ${differenzaOrario({dataInizio:totaleOre*3600*1000})}`
        else
        commentoRimanenza.innerText=`Da pagare ancora a ${cellInfoUtente.data.nome} ${rimanenzaTotale.toFixed(2)}${convertiValuta(periodiInteressati[0]["workperiodfixedsalarycurrency"])} di fisso.`
        commentoRimanenza.style.fontFamily="Poppins"
        commentoRimanenza.style.color = "red";
        commentoRimanenza.style.fontWeight="bold"
        commentoRimanenza.style.fontSize="22px"
    commentoRimanenza.dataset.rimanenzaTotale = rimanenzaTotale;
        divGen.appendChild(commentoRimanenza)
    for (let periodo of periodiInteressati){
        let stipendiPeriodo=[]
        let stipendiPeriodoOre=[]
        for (let stipendio of stipendiUtente){
            if(  stipendio.salaryfixed===0 && (DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"})&&DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"}))  ){
                stipendiPeriodo=[...stipendiPeriodo,stipendio]
            }
            else if (  stipendio.salaryfixed===1 && (DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"})&&DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"}))  ) {
                stipendiPeriodoOre=[...stipendiPeriodoOre,stipendio]
            }
        }
        let lezioniPeriodo=[]
        for (let lezione of lezioniUtente){
            if( DateTime.fromFormat(lezione["lessondatestart"],"yyyyMMddHHmm",{zone:"utc"})<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"})&&DateTime.fromFormat(lezione["lessondatestart"],"yyyyMMddHHmm",{zone:"utc"})>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"})){
                lezioniPeriodo=[...lezioniPeriodo,lezione]
            }
        }
        let noleggiPeriodo=[]
        for (let noleggio of noleggiUtente){
            if( DateTime.fromFormat(noleggio["rentinvlinkfrom"],"yyyyMMddHHmm",{zone:"utc"})<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"})&&DateTime.fromFormat(noleggio["rentinvlinkfrom"],"yyyyMMddHHmm",{zone:"utc"})>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"})){
                noleggiPeriodo=[...noleggiPeriodo,noleggio]
            }
        }
        const commento=document.createElement("h1")
        commento.innerText=`Periodo che va dal ${DateTime.fromFormat(periodo.workperioddatefrom,"yyyyMMdd",{ zone: 'utc' }).toFormat("dd/MM/yyyy")} al ${DateTime.fromFormat(periodo.workperioddateto,"yyyyMMdd",{ zone: 'utc' }).toFormat("dd/MM/yyyy")}`
        commento.style.fontWeight="bold"
        commento.style.fontFamily="Poppins"
        commento.style.fontSize="25px"
        divGen.appendChild(commento)
        const divTabStipWrapp=document.createElement("div")
        const divTabellStip=document.createElement("div")
        const commentoStipendi=document.createElement("h2")
        commentoStipendi.style.marginBottom="0px"
        commentoStipendi.innerText=`Dettagli stipendi fissi`
        commentoStipendi.style.fontWeight="bold"
        commentoStipendi.style.fontFamily="Poppins"
        commentoStipendi.style.fontSize="20px"
        divTabStipWrapp.appendChild(commentoStipendi)
        divTabellStip.id="gridContainerStipendi"+periodo.workperioddatefrom
        divTabStipWrapp.appendChild(divTabellStip);
        const button = document.createElement("button");
          button.id = "pagaBtn"+periodo.workperioddatefrom;
          button.style.marginTop="10px"
          button.textContent = "Segna come pagato";
          divTabStipWrapp.appendChild(button);
        if (periodo.workperiodfixedsalary!==0)
        divGen.appendChild(divTabStipWrapp)
        const divWrapLez=document.createElement("div")

        const divTabellOre=document.createElement("div")
        divTabellOre.id="gridContainerOre"+periodo.workperioddatefrom
        const divTabellOrePag=document.createElement("div")
        divTabellOrePag.id="gridContainerPagOre"+periodo.workperioddatefrom
        const commentoLezioni=document.createElement("h2")
        commentoLezioni.style.marginBottom="0px"
        commentoLezioni.innerText=`Dettagli lezioni`
        commentoLezioni.style.fontFamily="Poppins"
        commentoLezioni.style.fontWeight="bold"
        commentoLezioni.style.fontSize="20px"
        divWrapLez.appendChild(commentoLezioni)
        divWrapLez.appendChild(divTabellOre)
        const button2 = document.createElement("button");
          button2.id = "pagaBtn2"+periodo.workperioddatefrom;
          button2.style.marginTop="10px"
          button2.textContent = "Segna come pagato";
          divWrapLez.appendChild(button2);
        if (cellInfoUtente.data.ruolo===2||cellInfoUtente.data.ruolo===1|| cellInfoUtente.data.ruolo===5) {
            divGen.appendChild(divWrapLez)
            divGen.appendChild(divTabellOrePag)

        }
        if (noleggiPeriodo.length>0){
            const divWrapNol=document.createElement("div")

        const divTabellOreNol=document.createElement("div")
        divTabellOreNol.id="gridContainerOreNol"+periodo.workperioddatefrom
        const commentoNoleggi=document.createElement("h2")
        commentoNoleggi.style.marginBottom="0px"
        commentoNoleggi.innerText=`Dettagli noleggi assistiti`
        commentoNoleggi.style.fontFamily="Poppins"
        commentoNoleggi.style.fontWeight="bold"
        commentoNoleggi.style.fontSize="20px"
        divWrapNol.appendChild(commentoNoleggi)
        divWrapNol.appendChild(divTabellOreNol)
        const button3 = document.createElement("button");
          button3.id = "pagaBtn3"+periodo.workperioddatefrom;
          button3.style.marginTop="10px"
          button3.textContent = "Segna come pagato";
          divWrapNol.appendChild(button3);
        divGen.appendChild(divWrapNol)
        }
        let formattedRowsStipendiOre=[]

        let formattedRowsStipendi=[]
        const allineamento="center"
        const stipendi = generaStipendi(
          cellInfoUtente.data.userid,
          periodo.workperiodfixedsalary,
          periodo.workperiodfixedsalaryfreq,
          periodo.workperioddatefrom,
          periodo.workperioddateto,
          stipendiPeriodo
        );
        let contatore=0
        for (let stipendio of stipendi){
            contatore-=1
            formattedRowsStipendi=[...formattedRowsStipendi,{"id":stipendio.salaryid?stipendio.salaryid:contatore,"inizio":convertDate(stipendio.salarydatefrom).toISO({ includeOffset: false }),"fine":convertDate(stipendio.salarydateto).toISO({ includeOffset: false }),"importo":stipendio.importo?stipendio.importo:stipendio.salaryvalue,"pagato":stipendio.pagato}]
        }
        for (let stipendio of stipendiPeriodoOre){
            if (stipendio.salaryfixed!==0)
            formattedRowsStipendiOre=[...formattedRowsStipendiOre,{"salaryid":stipendio.salaryid,"data":convertDate(stipendio.salarydateto).toISO({ includeOffset: false }),"importo":stipendio.salaryvalue,"valuta":stipendio.salarycurrency,note:stipendio.salarynotes}]
        }
        let formattedRowsLezioni=[]
        let totaleIncome=0
        for (let lezione of lezioniPeriodo){
            for (let pacchetto of pacchetti){
                if (pacchetto.lessonid===lezione.lessonid){
                    const nome = pacchetto.lessonstudentname
                    const numero = pacchetto.lessonnumstudents
                    const durata=((convertDate(lezione.lessondateend)-convertDate(lezione.lessondatestart))/(3600*1000))
                    let paga= numero===1?((convertDate(lezione.lessondateend)-convertDate(lezione.lessondatestart))/(3600*1000))*(periodo.workperiodhourlypayment):((convertDate(lezione.lessondateend)-convertDate(lezione.lessondatestart))/(3600*1000))*(periodo.workperiodhourlypaymentgroups)
                    if (cellInfoUtente.data.ruolo===5 && pacchetto.lessontype==="Avanzata"){
                        let commissionLez=0
                        if (lezione.inventories.length>0)
                            commissionLez=periodo.workperiodcommissionratelessonmaterial/100
                        else
                            commissionLez=periodo.workperiodcommissionratelesson/100
                        paga=((pacchetto.lessoncost * (1 - (pacchetto.lessondiscount || 0) / 100))*commissionLez*durata)/pacchetto.lessonpacket
                    }
                    totaleIncome+=paga
                    formattedRowsLezioni=[...formattedRowsLezioni,{"lessondateid":lezione.lessondateid,"inizio":convertDate(lezione.lessondatestart).toISO({ includeOffset: false }),"fine":convertDate(lezione.lessondateend).toISO({ includeOffset: false }),"studente":nome,"durata":differenzaOrario({dataInizio:convertDate(lezione.lessondateend)-convertDate(lezione.lessondatestart)}),"stipendiolez":paga,"pagato":0}]
                }
            }
        }
        let daPagar=0
        let contatoreLezioni=0
        let totalePagatoV=0
        for (let stipendio of stipendiPeriodoOre){
            if (stipendio.salaryfixed!==0){
                totalePagatoV+=stipendio.salaryvalue
            }
        }
        let esciWhile=false
        while (daPagar<totalePagatoV){
            const lezione=lezioniPeriodo[contatoreLezioni]
            for (let pacchetto of pacchetti){
                if ( lezione && pacchetto.lessonid===lezione.lessonid){
                    const nome = pacchetto.lessonstudentname
                    const numero = pacchetto.lessonnumstudents
                    const durata=(convertDate(lezione.lessondateend)-convertDate(lezione.lessondatestart))/(3600*1000)
                    let paga= numero===1?durata*(periodo.workperiodhourlypayment):durata*(periodo.workperiodhourlypaymentgroups)
                    if (cellInfoUtente.data.ruolo===5 && pacchetto.lessontype==="Avanzata"){
                        let commissionLez=0
                        if (lezione.inventories.length>0)
                            commissionLez=periodo.workperiodcommissionratelessonmaterial/100
                        else
                            commissionLez=periodo.workperiodcommissionratelesson/100
                        paga=((pacchetto.lessoncost * (1 - (pacchetto.lessondiscount || 0) / 100))*commissionLez*durata)/pacchetto.lessonpacket
                    }
                    daPagar+=paga
                    formattedRowsLezioni[contatoreLezioni].pagato=1

                }
                else if (!lezione){
                    esciWhile=true
                }
            }
            contatoreLezioni+=1
            if (esciWhile)break

        }
        let formattedRowsNoleggi=[]
            for (let noleggio of noleggiPeriodo){
                for (let pacchetto of noleggi){
                    if (pacchetto.rentalid===noleggio.rentalid){
                        const nome = pacchetto.rentalcustname
                        const durata=((convertDate(noleggio.rentinvlinkto)-convertDate(noleggio.rentinvlinkfrom))/(3600*1000))
                        let paga=durata*periodo.workperiodcommissionrental
                        formattedRowsNoleggi=[...formattedRowsNoleggi,{"rentinvlinkid":noleggio.rentinvlinkid,"inizio":convertDate(noleggio.rentinvlinkfrom).toISO({ includeOffset: false }),"fine":convertDate(noleggio.rentinvlinkto).toISO({ includeOffset: false }),"cliente":nome,"durata":differenzaOrario({dataInizio:convertDate(noleggio.rentinvlinkto)-convertDate(noleggio.rentinvlinkfrom)}),"stipendionol":paga,"pagato":noleggio.rentalpaid}]
                    }
                }
            }

    setTimeout(()=>{
        const $btn2 = $("#pagaBtn2"+periodo.workperioddatefrom);
        $btn2.hide();
        $("#gridContainerOre"+periodo.workperioddatefrom).dxDataGrid({
        dataSource:formattedRowsLezioni,
        columns:[
        {dataField:"inizio",caption: "Inizio Lezione",hidingPriority:2,
        sortOrder: "desc",
         alignment:allineamento,
          customizeText: function (e) {
            return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy, HH:mm");
          }
         },
         {dataField:"fine",caption: "Fine Lezione",hidingPriority:3,
         alignment:allineamento,
          customizeText: function (e) {
            return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy, HH:mm");
          }
         },
         {dataField:"studente",caption: "Nome studente",hidingPriority:4,
         alignment:allineamento,
         },
         {dataField:"durata",caption: "Durata Lezione",hidingPriority:5,
         alignment:allineamento,
         },
         {dataField:"stipendiolez",caption: "Stipendio Lezione",hidingPriority:6,
         alignment:allineamento,
          cellTemplate: (cellElement, cellInfo) => {
            const root = ReactDOM.createRoot(cellElement.get(0));
            root.render(
        <div style={{ fontFamily: "Poppins, sans-serif" }}>
            {cellInfo.value.toFixed(2)}{convertiValuta(periodo.workperiodfixedsalarycurrency)}
        </div>)},
         },
         {
          dataField: "pagato",
          caption: "Pagato",
          dataType: "boolean",hidingPriority:1
        },


        ],
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        columnHidingEnabled: true,
        onRowPrepared: function (e) {
          if (e.rowType === "data" && e.rowElement && e.data) {
            if (!e.data.pagato) {
              e.rowElement.addClass("row-warning");
              e.rowElement[0].bgColor = "#ffe6e6";
            }
          }
        },
        keyExpr: "lessondateid",
      selection: {
        mode: "multiple"
      },
      onSelectionChanged: function (e) {
      if (e.selectedRowKeys.length > 0) {
        $btn2.show();
      } else {
        $btn2.hide();
      }
    },

        })
        $("#gridContainerPagOre"+periodo.workperioddatefrom).dxDataGrid({
        dataSource:formattedRowsStipendiOre,
        columns:[
         {dataField:"importo",caption: "Importo Stipendio",hidingPriority:5,
         alignment:allineamento,
             editCellTemplate: function (cellElement,cellInfo) {
                 let valoreString="val_importo_stip"+periodo.workperioddatefrom
          if ($("#val_importo_stip"+periodo.workperioddatefrom).length===0) {
                $(`<div id=${valoreString}></div>`).appendTo(cellElement)
            }
            $("#val_importo_stip"+periodo.workperioddatefrom).dxNumberBox({
                min:0,value:cellInfo.value,format:`#0.##${convertiValuta(cellInfo.data.valuta)}`, onValueChanged: function(e) {

            cellInfo.setValue(e.value)}
            })
             },
             calculateDisplayValue:function(rowData){return `${rowData.importo?rowData.importo.toLocaleString("it-IT", { maximumFractionDigits: 2 }):0} ${convertiValuta(rowData.valuta)}`}
         },
             { dataField: "valuta",visible:false, alignment:allineamento,caption:"Valuta stipendio",hidingPriority:5,customizeText: function (e){
          return convertiValuta(e.value)},
          editCellTemplate: function (cellElement,cellInfo) {
             let valoreString="val_valuta_ore"+periodo.workperioddatefrom
          if ($("#val_valuta_ore"+periodo.workperioddatefrom).length===0) {
                $(`<div id=${valoreString}></div>`).appendTo(cellElement)
            }
            let dati_ut=[]
              let inizio=0
              while (convertiValuta(inizio)){
                dati_ut.push({id:inizio,name:convertiValuta(inizio)})
                  inizio+=1
              }
            $("#val_valuta_ore"+periodo.workperioddatefrom).dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            $("#val_importo_stip"+periodo.workperioddatefrom).dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
            }})
          },
        },

         {
          dataField: "note",
          caption: "Note Stipendio",
        },
            {
            dataField: "data",
            caption: "Data",
            sortOrder: "desc",
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
            let valoreString="val_reg"+periodo.workperioddatefrom
          if ($("#val_reg"+periodo.workperioddatefrom).length===0) {
                $(`<div id=${valoreString}></div>`).appendTo(cellElement)
            }
            $("#val_reg"+periodo.workperioddatefrom).dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value, onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            }})
          },
                customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value,).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }
          },


        ],
            onInitNewRow:
             function (e) {
  e.data.importo = 0;
  e.data.data = DateTime.now().toISODate();
  e.data.valuta=periodo.workperiodfixedsalarycurrency
},
            onRowUpdated:async function(e){
                let lux=null
            if (!(e.data.data instanceof Date))
            lux=DateTime.fromISO(e.data.data)
            else
            lux=DateTime.fromJSDate(e.data.data)
                const dati={salarydateto:lux.toFormat("yyyyMMdd"),salaryvalue:e.data.importo,salarynotes:e.data.note,salarycurrency:e.data.valuta,salaryfixed:1}
                const richiesta=funzione_collegamento({
                    userid: getUserId(), token: getToken(),
                    azione:"setSalaryItem",
                    setId:e.data.salaryid,
                    valori:dati
                }

            )
                const commentoRimanenza=document.getElementById("commentoRimanenza");
                const valore = parseFloat(
                  document.getElementById("commentoRimanenza").dataset.rimanenzaTotale
                );
                let prima=0
                for (let stipendio of stipendiPeriodoOre){
                    if (stipendio.salaryid===e.data.salaryid){
                        prima=stipendio.salaryvalue
                    }
                }
                const nuovo=valore-e.data.importo+prima
        commentoRimanenza.innerText=`Da pagare ancora a ${cellInfoUtente.data.nome} ${(nuovo).toFixed(2)}${convertiValuta(periodiInteressati[0]["workperiodfixedsalarycurrency"])}.`
            },
            onRowInserting:async function(e){
            let lux=null
            if (!(e.data.data instanceof Date))
            lux=DateTime.fromISO(e.data.data)
            else
            lux=DateTime.fromJSDate(e.data.data)
                const dati={salarydateto:lux.toFormat("yyyyMMdd"),salaryvalue:e.data.importo,salarynotes:e.data.note,salarycurrency:e.data.valuta,salaryfixed:1,userid:cellInfoUtente.data.userid}
                const richiesta=funzione_collegamento({
                    userid: getUserId(), token: getToken(),
                    azione:"setSalaryItem",
                    valori:dati
                })
            },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        columnHidingEnabled: true,
            editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            width:"80%",
            height:"auto",
            maxHeight:"90%",
            title: `Modifica stipendio`,
            showTitle: true,
          },
          form: {
          colCount: 1,
            items: [

              {
                itemType: "group",
                colCount: 2,
                items: [{ dataField: "data", label: { text: "Data Pagamento" } },
                { dataField: "importo", label: { text: "Importo stipendio" } },{ dataField: "valuta", label: { text: "Valuta Stipendio" } },{ dataField: "note", label: { text: "Note Stipendio" } },
                ],
              },

            ],
          },
      },

        })
        const $btn3 = $("#pagaBtn3"+periodo.workperioddatefrom);
        $btn3.hide();
        $("#gridContainerOreNol"+periodo.workperioddatefrom).dxDataGrid({
        dataSource:formattedRowsNoleggi,
        columns:[
        {dataField:"inizio",caption: "Inizio Noleggio",hidingPriority:2,
        sortOrder: "desc",
         alignment:allineamento,
          customizeText: function (e) {
            return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy, HH:mm");
          }
         },
         {dataField:"fine",caption: "Fine Noleggio",hidingPriority:3,
         alignment:allineamento,
          customizeText: function (e) {
            return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy, HH:mm");
          }
         },
         {dataField:"cliente",caption: "Nome",hidingPriority:4,
         alignment:allineamento,
         },
         {dataField:"durata",caption: "Durata Noleggio",hidingPriority:5,
         alignment:allineamento,
         },
         {dataField:"stipendionol",caption: "Stipendio Assistente",hidingPriority:6,
         alignment:allineamento,
          cellTemplate: (cellElement, cellInfo) => {
            const root = ReactDOM.createRoot(cellElement.get(0));
            root.render(
        <div style={{ fontFamily: "Poppins, sans-serif" }}>
            {cellInfo.value.toFixed(2)}{convertiValuta(periodo.workperiodfixedsalarycurrency)}
        </div>)},
         },
         {
          dataField: "pagato",
          caption: "Pagato",
          dataType: "boolean",hidingPriority:1
        }


        ],
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        columnHidingEnabled: true,
        onRowPrepared: function (e) {
          if (e.rowType === "data" && e.rowElement && e.data) {
            if (!e.data.pagato) {
              e.rowElement.addClass("row-warning");
              e.rowElement[0].bgColor = "#ffe6e6";
            }
          }
        },
        keyExpr: "rentinvlinkid",
      selection: {
        mode: "multiple"
      },
      onSelectionChanged: function (e) {
      if (e.selectedRowKeys.length > 0) {
        $btn3.show();
      } else {
        $btn3.hide();
      }
    },

        })
        const $btn = $("#pagaBtn"+periodo.workperioddatefrom);
        $btn.hide();
        $("#gridContainerStipendi"+periodo.workperioddatefrom).dxDataGrid({
            dataSource: formattedRowsStipendi,
      keyExpr: "id",
      selection: {
        mode: "multiple"
      },
      rowAlternationEnabled: true,
        columnAutoWidth: true,
        columnHidingEnabled: true,
      editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            width:"70%",
            height:"auto",
            maxHeight:"90%",
            title: `Modifica stipendio`,
            showTitle: true,
          },
          form: {
          colCount: 1,
            items: [

              {
                itemType: "group",
                colCount: 2,
                items: [
                { dataField: "inizio", label: { text: "Stipendio da" } },{ dataField: "fine", label: { text: "Stipendio a" } },
                ],
              },
              {
                itemType: "group",
                colCount: 1,
                items: [
                { dataField: "importo", label: { text: "Importo" } }
                ],
              },

            ],
          },
      },
      onRowRemoving: async function (e) {
      if (e.data.id>0){
        const richiesta=  await funzione_collegamento({
           userid: getUserId(),
            token: getToken(),
            logout_on_error: true,
            delId:e.data.id,
            azione:'delSalaryItem',
            return_data:false})
        if (richiesta) {
            const message = `Articolo eliminato con successo`;
            window.DevExpress.ui.notify({message,
            position: {
              my: 'center',
              at: 'center',
              of: '#gridContainer',
            },}, "success", 1000);}
             let stipendiUtente=[]
        let stipendiSer=await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    azione: "getSalaryItems",
                })
        for (let stipendio of stipendiSer){
            if (stipendio.userid===cellInfoUtente.data.userid){
                stipendiUtente=[...stipendiUtente,stipendio]
            }
        }
        let stipendiPeriodo=[]
        let stipendiPeriodoOre=[]
        for (let stipendio of stipendiUtente){
            if(  stipendio.salaryfixed===0 && (DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"})&&DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"}))  ){
                stipendiPeriodo=[...stipendiPeriodo,stipendio]
            }
            else if (  stipendio.salaryfixed===1 && (DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"})&&DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"}))  ) {
                stipendiPeriodoOre=[...stipendiPeriodoOre,stipendio]
            }
        }
        const stipendi = generaStipendi(
          cellInfoUtente.data.userid,
          periodo.workperiodfixedsalary,
          periodo.workperiodfixedsalaryfreq,
          periodo.workperioddatefrom,
          periodo.workperioddateto,
          stipendiPeriodo
        );
        let contatore=0
        formattedRowsStipendi=[]
        for (let stipendio of stipendi){
            contatore-=1
            formattedRowsStipendi=[...formattedRowsStipendi,{"id":stipendio.salaryid?stipendio.salaryid:contatore,"inizio":convertDate(stipendio.salarydatefrom).toISO({ includeOffset: false }),"fine":convertDate(stipendio.salarydateto).toISO({ includeOffset: false }),"importo":stipendio.importo?stipendio.importo:stipendio.salaryvalue,"pagato":stipendio.pagato}]
        }
        $("#gridContainerStipendi"+periodo.workperioddatefrom).dxDataGrid("instance").option("dataSource",formattedRowsStipendi)

    }
},

    onRowInserting: async function (e) {

        // Aggiungi la classe di animazione alla griglia
        $("#loadingOverlay").show();
         $("#gridContainer").addClass("grid-container-hidden");

        // Rimuovi la classe dopo l'animazione

    const dati_n={"userid":cellInfoUtente.data.userid,'salarydatefrom':convertDate(DateTime.fromISO(e.data.inizio)),'salarydateto':convertDate(DateTime.fromISO(e.data.fine)),"salaryvalue":e.data.importo};
    const richiesta= await  funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        valori:dati_n,
        azione:'setSalaryItem'})
    if (richiesta) {
        const message = `Articolo aggiunto con successo`;

  window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainer',
        },}, "success", 1000);
         let stipendiUtente=[]
        let stipendiSer=await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    azione: "getSalaryItems",
                })
        for (let stipendio of stipendiSer){
            if (stipendio.userid===cellInfoUtente.data.userid){
                stipendiUtente=[...stipendiUtente,stipendio]
            }
        }
        let stipendiPeriodo=[]
        let stipendiPeriodoOre=[]
        for (let stipendio of stipendiUtente){
            if(  stipendio.salaryfixed===0 && (DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"})&&DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"}))  ){
                stipendiPeriodo=[...stipendiPeriodo,stipendio]
            }
            else if (  stipendio.salaryfixed===1 && (DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"})&&DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"}))  ) {
                stipendiPeriodoOre=[...stipendiPeriodoOre,stipendio]
            }
        }
        const stipendi = generaStipendi(
          cellInfoUtente.data.userid,
          periodo.workperiodfixedsalary,
          periodo.workperiodfixedsalaryfreq,
          periodo.workperioddatefrom,
          periodo.workperioddateto,
          stipendiPeriodo
        );
        let contatore=0
        formattedRowsStipendi=[]
        for (let stipendio of stipendi){
            contatore-=1
            formattedRowsStipendi=[...formattedRowsStipendi,{"id":stipendio.salaryid?stipendio.salaryid:contatore,"inizio":convertDate(stipendio.salarydatefrom).toISO({ includeOffset: false }),"fine":convertDate(stipendio.salarydateto).toISO({ includeOffset: false }),"importo":stipendio.importo?stipendio.importo:stipendio.salaryvalue,"pagato":stipendio.pagato}]
        }
        $("#gridContainerStipendi"+periodo.workperioddatefrom).dxDataGrid("instance").option("dataSource",formattedRowsStipendi)
      setTimeout(() => {
            $("#gridContainer").removeClass("grid-container-hidden");
            $("#loadingOverlay").hide();
        }, 100);
        }
    },
      onRowUpdated: async function (e){
        const gridElement = $("#gridContainerStipendi"+periodo.workperioddatefrom); // Ottieni l'intera griglia

                // Aggiungi la classe di animazione alla griglia
                gridElement.addClass("table-updated");

                // Rimuovi la classe dopo l'animazione
                setTimeout(() => {
                    gridElement.removeClass("table-updated");
                }, 1000);
            //const nomiLista=e.data.nomi
            if (e.data.pagato){
                const dati_n={'salarydatefrom':convertDate(DateTime.fromISO(e.data.inizio)),'salarydateto':convertDate(DateTime.fromISO(e.data.fine)),"salaryvalue":e.data.importo};
                const richiesta = await funzione_collegamento({
                   userid: getUserId(),
                    token: getToken(),
                    logout_on_error: true,
                    setId:e.data.id,
                    valori:dati_n,
                    azione:'setSalaryItem'})
                    if (richiesta) {
                    const message = `Stipendio modificato con successo`;

                    window.DevExpress.ui.notify({message,
                            position: {
                              my: 'center',
                              at: 'center',
                              of: '#gridContainerStorages',

                            },}, "success", 500);
                }}
                else {
                    const dati_n={"userid":cellInfoUtente.data.userid,'salarydatefrom':convertDate(DateTime.fromISO(e.data.inizio)),'salarydateto':convertDate(DateTime.fromISO(e.data.fine)),"salaryvalue":e.data.importo};
                const richiesta = await funzione_collegamento({
                   userid: getUserId(),
                    token: getToken(),
                    logout_on_error: true,
                    valori:dati_n,
                    azione:'setSalaryItem'})
                    if (richiesta) {
                    const message = `Stipendio modificato con successo`;

                    window.DevExpress.ui.notify({message,
                            position: {
                              my: 'center',
                              at: 'center',
                              of: '#gridContainerStorages',

                            },}, "success", 500);
                }

                let stipendiUtente=[]
        let stipendiSer=await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    azione: "getSalaryItems",
                })
        for (let stipendio of stipendiSer){
            if (stipendio.userid===cellInfoUtente.data.userid){
                stipendiUtente=[...stipendiUtente,stipendio]
            }
        }
        let stipendiPeriodo=[]
        let stipendiPeriodoOre=[]
        for (let stipendio of stipendiUtente){
            if(  stipendio.salaryfixed===0 && (DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"})&&DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"}))  ){
                stipendiPeriodo=[...stipendiPeriodo,stipendio]
            }
            else if (  stipendio.salaryfixed===1 && (DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"})&&DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"}))  ) {
                stipendiPeriodoOre=[...stipendiPeriodoOre,stipendio]
            }
        }
        const stipendi = generaStipendi(
          cellInfoUtente.data.userid,
          periodo.workperiodfixedsalary,
          periodo.workperiodfixedsalaryfreq,
          periodo.workperioddatefrom,
          periodo.workperioddateto,
          stipendiPeriodo
        );
        let contatore=0
        formattedRowsStipendi=[]
        for (let stipendio of stipendi){
            contatore-=1
            formattedRowsStipendi=[...formattedRowsStipendi,{"id":stipendio.salaryid?stipendio.salaryid:contatore,"inizio":convertDate(stipendio.salarydatefrom).toISO({ includeOffset: false }),"fine":convertDate(stipendio.salarydateto).toISO({ includeOffset: false }),"importo":stipendio.importo?stipendio.importo:stipendio.salaryvalue,"pagato":stipendio.pagato}]
        }
        $("#gridContainerStipendi"+periodo.workperioddatefrom).dxDataGrid("instance").option("dataSource",formattedRowsStipendi)
            }

      },
      onRowPrepared: function (e) {
          if (e.rowType === "data" && e.rowElement && e.data) {
            if (!e.data.pagato) {
              e.rowElement.addClass("row-warning");
              e.rowElement[0].bgColor = "#ffe6e6";
            }
          }
        },
      onSelectionChanged: function (e) {
      if (e.selectedRowKeys.length > 0) {
        $btn.show();
      } else {
        $btn.hide();
      }
    },
      columns: [
        { dataField: "inizio", caption: "Inizio periodo",hidingPriority:1,
         alignment:allineamento,
          customizeText: function (e) {
            return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy");
          },
          editCellTemplate: function (cellElement,cellInfo) {
          let valoreString="val_inizio"+periodo.workperioddatefrom
          if ($("#val_inizio"+periodo.workperioddatefrom).length===0) {
                $(`<div id=${valoreString}></div>`).appendTo(cellElement)
            }
            $("#val_inizio"+periodo.workperioddatefrom).dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value, onValueChanged: function(e) {
            let valoreI=null
            if (e.value instanceof Date) {
                valoreI=DateTime.fromJSDate(e.value).toISO({includeOffset:false})
                cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                valoreI=e.value
                cellInfo.setValue(e.value)
            }
            const valoreInizio=DateTime.fromISO(valoreI,{zone:"utc"})
            const valoreFine=DateTime.fromISO($("#val_fine"+periodo.workperioddatefrom).dxDateBox("instance").option("value"),{zone:"utc"})
            const giorniNuovi=(valoreFine-valoreInizio)/(3600*1000*24)
            let stipendioNuovo=0
            if (periodo.workperiodfixedsalaryfreq===1){
                stipendioNuovo=(giorniNuovi/7)*periodo.workperiodfixedsalary
            }
            else {
                stipendioNuovo=(giorniNuovi/30)*periodo.workperiodfixedsalary
            }
            $("#val_importo"+periodo.workperioddatefrom).dxNumberBox("instance").option("value",Math.round(stipendioNuovo))
            }})
          }},
        { dataField: "fine", caption: "Fine periodo",hidingPriority:3,alignment:allineamento,
          customizeText: function (e) {
            return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy");
          },
          editCellTemplate: function (cellElement,cellInfo) {
          let valoreString="val_fine"+periodo.workperioddatefrom
          if ($("#val_fine"+periodo.workperioddatefrom).length===0) {
                $(`<div id=${valoreString}></div>`).appendTo(cellElement)
            }
            $("#val_fine"+periodo.workperioddatefrom).dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value, onValueChanged: function(e) {
            let valoreF=null
            if (e.value instanceof Date) {
                valoreF=DateTime.fromJSDate(e.value).toISO({includeOffset:false})
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                valoreF=e.value
                cellInfo.setValue(e.value)
            }
            const valoreInizio=DateTime.fromISO($("#val_inizio"+periodo.workperioddatefrom).dxDateBox("instance").option("value"),{zone:"utc"})
            const valoreFine=DateTime.fromISO(valoreF,{zone:"utc"})
            const giorniNuovi=(valoreFine-valoreInizio)/(3600*1000*24)
            let stipendioNuovo=0
            if (periodo.workperiodfixedsalaryfreq===1){
                stipendioNuovo=(giorniNuovi/7)*periodo.workperiodfixedsalary
            }
            else {
                stipendioNuovo=(giorniNuovi/30)*periodo.workperiodfixedsalary
            }
            $("#val_importo"+periodo.workperioddatefrom).dxNumberBox("instance").option("value",Math.round(stipendioNuovo))
            }})
          }},
        { dataField: "importo", caption: "Importo",alignment:allineamento,hidingPriority:4, cellTemplate: (cellElement, cellInfo) => {
            const root = ReactDOM.createRoot(cellElement.get(0));
            root.render(
        <div style={{ fontFamily: "Poppins, sans-serif" }}>
            {cellInfo.value.toFixed(2)}{convertiValuta(periodo.workperiodfixedsalarycurrency)}
        </div>)},
        editCellTemplate: function (cellElement,cellInfo) {
        let valoreString="val_importo"+periodo.workperioddatefrom
            if ($("#val_importo"+periodo.workperioddatefrom).length===0) {
                $(`<div id=${valoreString}></div>`).appendTo(cellElement)
            }
            $("#val_importo"+periodo.workperioddatefrom).dxNumberBox({min:0,value:cellInfo.value,format:`#0.##'${convertiValuta(periodo.workperiodfixedsalarycurrency)}'`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)

            }})
          },
          },

        {
          dataField: "pagato",hidingPriority:2,alignment:allineamento,
          caption: "Pagato",
          dataType: "boolean",
          allowEditing: false
        }
      ]
    });

    $("#pagaBtn"+periodo.workperioddatefrom).on("click", async function () {
      const grid = $("#gridContainerStipendi"+periodo.workperioddatefrom).dxDataGrid("instance");
      const selected = grid.getSelectedRowKeys();
      $("#loadingOverlay").show()
      let stipendiSelez=[]
      for (let stipendio of formattedRowsStipendi){
        if (selected.includes(stipendio.id)){
            stipendiSelez.push(stipendio)
        }
      }
      let richiesta=null
      for (let stipendio of stipendiSelez){
        if (stipendio.id<0){
            const dati_n={"salarydatefrom":DateTime.fromISO(stipendio.inizio).toFormat("yyyyMMdd"),"salarydateto":DateTime.fromISO(stipendio.fine).toFormat("yyyyMMdd"),"salaryvalue":stipendio.importo,"userid":cellInfoUtente.data.userid}
             richiesta=await funzione_collegamento({
                        userid: getUserId(),
                        token: getToken(),
                        azione: "setSalaryItem",
                        valori:dati_n
                    })
        }
      }
      if (richiesta){
        const message = `Stipendio aggiunto con successo`;
        window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainer',
        },}, "success", 1000);
        let stipendiUtente=[]
        let stipendiSer=await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    azione: "getSalaryItems",
                })
        for (let stipendio of stipendiSer){
            if (stipendio.userid===cellInfoUtente.data.userid){
                stipendiUtente=[...stipendiUtente,stipendio]
            }
        }
        let stipendiPeriodo=[]
        let stipendiPeriodoOre=[]
        for (let stipendio of stipendiUtente){
            if(  stipendio.salaryfixed===0 && (DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"})&&DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"}))  ){
                stipendiPeriodo=[...stipendiPeriodo,stipendio]
            }
            else if (  stipendio.salaryfixed===1 && (DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"})&&DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"}))  ) {
                stipendiPeriodoOre=[...stipendiPeriodoOre,stipendio]
            }
        }
        const stipendi = generaStipendi(
          cellInfoUtente.data.userid,
          periodo.workperiodfixedsalary,
          periodo.workperiodfixedsalaryfreq,
          periodo.workperioddatefrom,
          periodo.workperioddateto,
          stipendiPeriodo
        );
        let contatore=0
        formattedRowsStipendi=[]
        for (let stipendio of stipendi){
            contatore-=1
            formattedRowsStipendi=[...formattedRowsStipendi,{"id":stipendio.salaryid?stipendio.salaryid:contatore,"inizio":convertDate(stipendio.salarydatefrom).toISO({ includeOffset: false }),"fine":convertDate(stipendio.salarydateto).toISO({ includeOffset: false }),"importo":stipendio.importo?stipendio.importo:stipendio.salaryvalue,"pagato":stipendio.pagato}]
        }
        $("#gridContainerStipendi"+periodo.workperioddatefrom).dxDataGrid("instance").option("dataSource",formattedRowsStipendi)

      }
      $("#loadingOverlay").hide()
    })
    $("#pagaBtn2"+periodo.workperioddatefrom).on("click", async function () {
      const grid = $("#gridContainerOre"+periodo.workperioddatefrom).dxDataGrid("instance");
      const selected = grid.getSelectedRowKeys();
      let lezioniSelez=[]
      $("#loadingOverlay").show()
      for (let lezione of formattedRowsLezioni){
        if (selected.includes(lezione.lessondateid)){
            lezioniSelez.push(lezione)
        }
      }
      let richiesta=null
      for (let lezione of lezioniSelez){
          const dati_n={"lessondatepaid":lezione.pagato===1?0:1}
          richiesta=await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    setId:lezione.lessondateid,
                    valori:dati_n,
                    azione: "setLessonDate",
                })
      }
      if (richiesta){
        const message = `Stipendio aggiunto con successo`;
        window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainer',
        },}, "success", 1000);
        let lezioniUtente=[]
        let lezioniSer=await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    azione: "getLessonDates",
                    childs:["inventories"]
                })
        for (let lezione of lezioniSer){
            if (lezione.userid===cellInfoUtente.data.userid){
                lezioniUtente=[...lezioniUtente,lezione]
            }
        }
        let lezioniPeriodo=[]
        for (let lezione of lezioniUtente){
            if( DateTime.fromFormat(lezione["lessondatestart"],"yyyyMMddHHmm",{zone:"utc"})<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"})&&DateTime.fromFormat(lezione["lessondatestart"],"yyyyMMddHHmm",{zone:"utc"})>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"})){
                lezioniPeriodo=[...lezioniPeriodo,lezione]
            }
        }
        formattedRowsLezioni=[]
        for (let lezione of lezioniPeriodo){
            for (let pacchetto of pacchetti){
                if (pacchetto.lessonid===lezione.lessonid){
                    const nome = pacchetto.lessonstudentname
                    const numero = pacchetto.lessonnumstudents
                    let paga= numero===1?periodo.workperiodhourlypayment:periodo.workperiodhourlypaymentgroups
                    formattedRowsLezioni=[...formattedRowsLezioni,{"lessondateid":lezione.lessondateid,"inizio":convertDate(lezione.lessondatestart).toISO({ includeOffset: false }),"fine":convertDate(lezione.lessondateend).toISO({ includeOffset: false }),"studente":nome,"durata":differenzaOrario({dataInizio:convertDate(lezione.lessondateend)-convertDate(lezione.lessondatestart)}),"stipendiolez":((convertDate(lezione.lessondateend)-convertDate(lezione.lessondatestart))/(3600*1000))*paga,"pagato":lezione.lessondatepaid}]
                }
            }

        }
        $("#gridContainerOre"+periodo.workperioddatefrom).dxDataGrid("instance").option("dataSource",formattedRowsLezioni)

      }
      $("#loadingOverlay").hide()
    })
    $("#pagaBtn3"+periodo.workperioddatefrom).on("click", async function () {
      const grid = $("#gridContainerOreNol"+periodo.workperioddatefrom).dxDataGrid("instance");
      const selected = grid.getSelectedRowKeys();
      let noleggiSelez=[]
      $("#loadingOverlay").show()
      for (let noleggio of formattedRowsNoleggi){
        if (selected.includes(noleggio.rentinvlinkid)){
            noleggiSelez.push(noleggio)
        }
      }
      let richiesta=null
      for (let noleggio of noleggiSelez){
          const dati_n={"rentalpaid":noleggio.pagato===1?0:1}
          richiesta=await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    setId:noleggio.rentinvlinkid,
                    valori:dati_n,
                    azione: "setLinkRentInv",
                })
      }
      if (richiesta){
        const message = `Stipendio aggiunto con successo`;
        window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainer',
        },}, "success", 1000);

      }
      $("#loadingOverlay").hide()
    })
      },0)
    }
    return divGen
}
function handleClick(cellInfo,periodi,stipendi,lezioni,pacchetti,noleggi) {
    let stipendiUtente=[]
    let lezioniUtente=[]
    let noleggiUtente=[]
    for (let stipendio of stipendi){
        if (stipendio.userid===cellInfo.data.userid){
            stipendiUtente=[...stipendiUtente,stipendio]
        }
    }
    for (let lezione of lezioni){
        if (lezione.userid===cellInfo.data.userid && lezione.lessondatestatus===2){
            lezioniUtente=[...lezioniUtente,lezione]
        }
    }
    for (let noleggio of noleggi){
        const materiali=noleggio.inventories
        for (let materiale of materiali){
            if (materiale.assistedby===cellInfo.data.userid){
                noleggiUtente.push(materiale)
            }
        }
    }
    const content=mostraDettagliPagamenti(cellInfo,periodi,stipendiUtente,lezioniUtente,pacchetti,noleggiUtente,noleggi)
    $("#infoUtente").dxPopup("instance").option( "title",`Dettagli di ${cellInfo.data.nome}`);
    $("#infoUtente").dxPopup("instance").option("contentTemplate", () => content);
    $("#infoUtente").dxPopup("instance").show();
    }
function BounceIconButton({ icon, onClick, color = "#000" }) {
  const [isClicked, setIsClicked] = useState(false);


  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 800);
    onClick();
  };

  return (
    <button
      style={{
        cursor: "pointer",
        padding: "5px",
        background: "none",
        border: "none",
        color: color,
      }}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={icon} className={isClicked ? "fa-bounce" : ""} />
    </button>
  );
}

function TabellaPersonale(){
useEffect(() => {
    const fetchDati= async  () =>{

        $("#gridContainer").addClass("grid-container-hidden")
        $("#loadingOverlay").show();
        const lezioni = await funzione_collegamento({
            userid: getUserId(),
            token: getToken(),
            azione: "getLessonDates",
            childs:["inventories"],
            })
        const pacchetti = await funzione_collegamento({
            userid: getUserId(),
            token: getToken(),
            azione: "getLessons",
            })
        const noleggi=await funzione_collegamento({
            userid: getUserId(),
            token: getToken(),
            azione: "getRentals",
            childs:["inventories"],
            })
          //const dati= await noleggi_off()
        const utenti = await funzione_collegamento({
            userid: getUserId(),
            token: getToken(),
            azione: "getUsers",
            })
        const periodi= await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    azione: "getUserWorkPeriods",
                })
        const stipendi= await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    azione: "getSalaryItems",
                })
        let utentiOra=[]
        let utentiPassati=[]
        let utentiGen=[]
        const adesso=DateTime.now()
        for (let utente of utenti){
            for (let periodo of periodi){
                if (periodo.userid===utente.userid){
                    if ( (convertDate(periodo.workperioddatefrom)<=adesso && convertDate(periodo.workperioddateto)>=adesso  ) ){
                        if (!utentiOra.includes(utente))
                        utentiOra=[...utentiOra,utente]
                    }
                    else {
                        if (!utentiPassati.includes(utente))
                        utentiPassati=[...utentiPassati,utente]
                    }
                    if (!utentiGen.includes(utente))
                    utentiGen=[...utenti,utente]
                }
            }
        }
        const tabsIconAndText=[
      { id: 0, text: 'Dipendenti attuali'},
      { id: 1, text: 'Dipendenti passati'},
      { id: 2, text: 'Tutti'},
    ];

      const allineamento="center"

      const formattedRows=utentiOra.map((row,index) => ({
        id:index,
        userid:row.userid,
        nome:row.name,
        cognome:row.surname,
        email:row.email,
        attivo:row.enabled,
        ruolo:row.type,
        tel1:row.phonenumber1,
        tel2:row.phonenumber2,
        nomeUtente:row.user,
        password:row.pwd,
        ultimaConnessione:row.lastconnected,

    }))
    const tabella= $("#gridContainerPersonale").dxDataGrid({
    dataSource:formattedRows,
    columns:[
        {
          dataField: "nome",
          caption: "Nome",
          hidingPriority:9,
          alignment:allineamento,

        },
        {
          dataField: "cognome",
          caption: "Cognome",
          hidingPriority:10,
          alignment:allineamento,

        },
        {
          dataField: "ruolo",
          caption: "Ruolo",
          hidingPriority:8,
          alignment:allineamento,
          customizeText: function (e){
            return convertiIdRuolo(e.value)
          },
          editCellTemplate: function  (cellElement,cellInfo) {
          if ($("#val_ruolo").length===0) {
                $('<div id="val_ruolo"></div>').appendTo(cellElement)
            }
             const rowData = cellInfo.row.data;
             let dati_ut=[]
             for (let i = 0; i <= 4; i++) {
              dati_ut=[...dati_ut,{ID:i,nome:convertiIdRuolo(i)}]
            }
            $("#val_ruolo").dxSelectBox({dataSource:dati_ut , displayExpr:"nome",value:cellInfo.value,valueExpr:"ID",onValueChanged: function(e) {
            cellInfo.setValue(e.value)},
            elementAttr: {
                class: "istruttore-style"
              },
            })
          },
        },
        
        {
            type: "buttons",
            width:"50px",
            buttons: [
              {
                hint: "Dettagli Pagamenti",
                icon: "none",
                template: function (cellElement, cellInfo,) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faCircleInfo}
                      color="#03a9f4"
                      onClick={() => handleClick(cellInfo,periodi,stipendi,lezioni,pacchetti,noleggi)}
                    />
                  );
                },
              }
              ]}
      ],
        onRowPrepared: function (e) {
            setTimeout(() => {
                $("#gridContainerPersonale").removeClass("grid-container-hidden");
                $("#loadingOverlay").hide();},500)

        },

      showBorders: true,
      scrolling: { useNative: true },
      rowAlternationEnabled: true,
      columnAutoWidth: true,
      paging: { pageSize: 50 },
      height: "auto",
      width: "auto",
      columnHidingEnabled: true,

                })
      $('#tabsPersonaleAttuale').dxTabs({
      width: '100%',
      rtlEnabled: false,
      showNavButtons: false,
      dataSource: tabsIconAndText,
      orientation: "horizontal",
      stylingMode: "primary",
      iconPosition: "top",
      onSelectionChanged: function (e) {let  newIndex = e.component.option("selectedIndex");
        if (newIndex===-1)newIndex=0
        let utentiFormatt=[]
        if (newIndex===0)
         utentiFormatt=utentiOra.map((row,index) => ({
        id:index,
        userid:row.userid,
        nome:row.name,
        cognome:row.surname,
        email:row.email,
        attivo:row.enabled,
        ruolo:row.type,
        tel1:row.phonenumber1,
        tel2:row.phonenumber2,
        nomeUtente:row.user,
        password:row.pwd,
        ultimaConnessione:row.lastconnected,
    }))
        else if (newIndex===1)
         utentiFormatt=utentiPassati.map((row,index) => ({
        id:index,
        userid:row.userid,
        nome:row.name,
        cognome:row.surname,
        email:row.email,
        attivo:row.enabled,
        ruolo:row.type,
        tel1:row.phonenumber1,
        tel2:row.phonenumber2,
        nomeUtente:row.user,
        password:row.pwd,
        ultimaConnessione:row.lastconnected,
    }))
        else if (newIndex===2)
         utentiFormatt=utentiGen.map((row,index) => ({
        id:index,
        userid:row.userid,
        nome:row.name,
        cognome:row.surname,
        email:row.email,
        attivo:row.enabled,
        ruolo:row.type,
        tel1:row.phonenumber1,
        tel2:row.phonenumber2,
        nomeUtente:row.user,
        password:row.pwd,
        ultimaConnessione:row.lastconnected,
    }))
        $('#gridContainerPersonale').dxDataGrid("instance").option("dataSource",utentiFormatt)
      }
      })
      $('#tabsPersonaleAttuale').dxTabs("instance").option("selectedIndex", 0)
    let datiIstruttoriP={}
    for (let lezione of lezioni){
        const inizioLux=convertDate(lezione.lessondatestart)
        const fineLux=convertDate(lezione.lessondateend)
        if (sovrapposti(inizioP,fineP,lezione.lessondatestart,lezione.lessondateend) && lezione.lessondatestatus===2){
            const totaleOre=(fineLux-inizioLux)
            if (!(lezione.userid in datiIstruttoriP))datiIstruttoriP[lezione.userid]=0
            datiIstruttoriP[lezione.userid]+=totaleOre
        }
    }
    let datiIstruttori=[]
    for (let istruttore in datiIstruttoriP){
        datiIstruttori.push({nome:nome_id({id:parseInt(istruttore),utenti:utenti}),ore:datiIstruttoriP[istruttore]})
    }
$("#chartOreIstruttori").dxChart({
    dataSource: datiIstruttori,
    commonSeriesSettings: {
        argumentField: "nome",
        valueField: "ore",
        type: "bar",
        label: {
            visible: true,
            // Personalizza il testo sulle barre
            customizeText: function(point) {
                return differenzaOrario({dataInizio:point.value}); // es: "12.5 h"
            }
        }
    },
    series: [{}],
    title: "Ore per istruttore",
    legend: { visible: false },
    tooltip: {
        enabled: true,
        customizeTooltip: function(point) {
            return {
                text: differenzaOrario({dataInizio:point.value})
            };
        }
    },
    argumentAxis: {
        label: {
            overlappingBehavior: "rotate",
            rotationAngle: 45
        }
    },
    valueAxis: {
        tickInterval: 1000*60*60*10,
        label: {
            customizeText: function (axisInfo) {
                return differenzaOrario({ dataInizio: axisInfo.value });
            }
        }
    },
});

$("#infoUtente").dxPopup({
    width: "80%",
    height: '90%',
    visible: false,
    dragEnabled: true,
    closeOnOutsideClick: true,
    showCloseButton: true,
    onShown: function(e) {
    const popupHeight = e.component.option("height");
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScroll" style="height: 100%;"></div>');
    $("#customScroll").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    })}});
    }
    fetchDati()
},[])
    return <div>
        <div id="loadingOverlay">
      <div className="spinner">
        <Lottie  style={{  width: "30%", height: "30%" }} animationData={animLoading} loop={true} />
      </div>
    </div>
            <div id="tabsPersonaleAttuale"></div>
  <div id="gridContainerPersonale"></div>
  <div id="chartOreIstruttori"></div>
               <div style={{padding:"30px"}} id="infoUtente">
      <div className="popup-content">
      </div>
    </div>
           </div>
}

    return <div>
               <h2>Gestione Stipendi Personale</h2>
               <TabellaPersonale/>
           </div>
}

export default Instructors;